
type DateFormatterOptions = {
    locale?: string
    format?: Intl.DateTimeFormatOptions
}

export function useDateFormatter(options: DateFormatterOptions = {}) {
    const {locale = 'fa-IR', format} = options

    return ((dateStr: string|undefined) => {
        try {
            if (dateStr){
            const date = new Date(dateStr)
            return date?.toLocaleDateString(locale, format)
            }
        } catch (error) {
            console.error('Error formatting date:', error)
            return dateStr
        }
    })
}


export  function  useTimeFormatter (){

    return ((dateItem:string)=>{
        const date = new Date(dateItem);
        const formatter = new Intl.DateTimeFormat('fa-IR', {
            calendar: 'persian',
            timeZone: 'Asia/Tehran',
            hour: '2-digit',
            minute: '2-digit',
            // second: '2-digit',
        });
        return  formatter.format(date);
    })



}